module.exports = __webpack_public_path__ + "media/4x3/ae-9fd1fcbf.svg";